
// import { noRetryAxios as noRetryAxiosWeb, retryAxios as retryAxiosWeb } from '@eyparent-web/services/axios';
import { noRetryAxios as noRetryAxiosWeb, retryAxios as retryAxiosWeb, eymemoriesAxios as eymemoriesAxiosWeb } from '../../../../app/services/axios';
import axios, { AxiosInstance } from 'axios';

export const getAxiosInstance = () : { noRetryAxios: AxiosInstance, retryAxios: AxiosInstance, eymemoriesAxios: AxiosInstance } => {
    return { noRetryAxios: noRetryAxiosWeb, retryAxios: retryAxiosWeb, eymemoriesAxios: eymemoriesAxiosWeb };
}